/**
 * Legacy redirect: /admin/tags → /settings/tags.
 *
 * Tags moved under the Settings shell in the Apr-2026 nav re-org so
 * a single gear icon would surface every configuration surface
 * instead of each one bloating the top-bar nav. Kept as a redirect
 * so any bookmarks / external links / admin-tooling that hardcoded
 * the old path keep working.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/tags")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/tags" });
  },
});
